// extracted by css-extract-rspack-plugin
export default {"projectIcons":"emdgNDgDuJUAq2Wg","navIconTooltip":"ofnhqOeoBs8zTSBD"};